import React from "react";
import {
  Box,
  Flex,
  Text,
  useTheme,
  Button,
  Skeleton,
  InputGroup,
  InputRightElement,
  Icon,
} from "@chakra-ui/react";
import { Theme } from "../../theme";
import Cookies from "js-cookie";
import getAxios from "../../hooks/useAxios";
import Nodata from "../../components/Nodata";
import { useNavigate } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";
import { MdArrowBackIosNew, MdArrowForwardIos, MdSearch } from "react-icons/md";
import Input from "../../components/CustomInput";

function Index() {
  const theme = useTheme<Theme>();
  const axios = getAxios();
  const navigate = useNavigate();
  const access_token = Cookies.get("x-admin-auth");
  const [isDataFetching, setIsDataFetching] = React.useState(true);
  const [users, setUsers] = React.useState<any>([]);
  const [searchName, setSearchName] = React.useState("");
  const [searchMobile, setSearchMobile] = React.useState("");
  const [researchData, setResearchData] = React.useState("initial");
  const [pageNumber, setPageNumber] = React.useState(() => {
    return Number(localStorage.getItem("userpage")) || 1;
  });
  const [totalPages, setTotalPages] = React.useState<number>();
  const [totalUsers, setTotalUsers] = React.useState<number>();
  const [nextNotAllowed, setNextNotAllowed] = React.useState(false);
  const [refetchUrl, setRefetchUrl] = React.useState("/riders?page=1");

  const getAllUsers = async (url: string) => {
    setIsDataFetching(true);
    try {
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("all users", res.data);
      setUsers(res.data.data);
      setTotalPages(res.data.pagination.totalPages);
      setTotalUsers(res.data.pagination.total);
      if (res.data.length < 20) {
        setNextNotAllowed(true);
      } else {
        setNextNotAllowed(false);
      }
    } catch (error) {
      console.log("error listing users", error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleSearchData = (val: string) => {
    if (val === "name") {
      if (searchName !== "") {
        getAllUsers(`/riders?name=${searchName}`);
      } else {
        getAllUsers(refetchUrl);
      }
    } else {
      if (searchMobile !== "") {
        getAllUsers(`/riders?mobile=${searchMobile}`);
      } else {
        getAllUsers(refetchUrl);
      }
    }
  };

  React.useEffect(() => {
    getAllUsers(`/riders?page=${pageNumber}`);
  }, [pageNumber, researchData]);

  React.useEffect(() => {
    if (totalPages && totalPages === pageNumber) {
      setNextNotAllowed(true);
    } else {
      setNextNotAllowed(false);
    }
  }, [totalPages]);

  return (
    <Box sx={{ height: "100%", width: "100%", padding: "0 1rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading1,
          margin: "2.5rem 0 2rem 2rem",
        }}
      >
        All User List
      </Text>

      <Flex
        sx={{
          gap: "1rem",
          paddingLeft: "2rem",
          marginBottom: "2rem",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Flex sx={{ gap: "1rem" }}>
          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("name")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by name"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchName(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("name");
                  }
                }}
              />
            </InputGroup>
          </Box>

          <Box sx={{ height: "100%" }}>
            <InputGroup>
              <InputRightElement
                h="100%"
                cursor={"pointer"}
                onClick={() => handleSearchData("mobile")}
              >
                <MdSearch color={theme.colors.secondary.main} size={20} />
              </InputRightElement>
              <Input
                variant={"outline"}
                placeholder="Search by number"
                sx={{
                  height: "100%",
                }}
                borderColor={theme.colors.secondary.main}
                onChange={(e) => {
                  if (e.target.value !== "") {
                    setSearchMobile(e.target.value);
                  } else {
                    setResearchData(`again_${Math.random()}`);
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSearchData("mobile");
                  }
                }}
              />
            </InputGroup>
          </Box>
        </Flex>

        <Flex sx={{ marginRight: "3vw" }}>
          <Text
            sx={{
              fontSize: theme.fontSizes.body,
              marginRight: "0.25rem",
            }}
          >
            Total Users:
          </Text>
          <Skeleton isLoaded={!isDataFetching}>
            <Text
              sx={{
                fontSize: theme.fontSizes.body,
                color: "green",
              }}
            >
              {totalUsers}
            </Text>
          </Skeleton>
        </Flex>
      </Flex>

      <Box sx={{ marginTop: "1rem", paddingX: "2rem", width: "70%" }}>
        <Skeleton isLoaded={isDataFetching ? false : true} minHeight={"20rem"}>
          {users && users.length !== 0 ? (
            <table>
              <thead>
                <tr>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Name
                    </Text>
                  </th>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Mobile
                    </Text>
                  </th>
                  <th>
                    <Text
                      sx={{
                        fontSize: theme.fontSizes.subHeading1,
                      }}
                    >
                      Actions
                    </Text>
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((item: any, index: number) => (
                  <tr>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.name}
                      </Text>
                    </td>
                    <td>
                      <Text
                        sx={{
                          fontSize: theme.fontSizes.subHeading2,
                        }}
                      >
                        {item.mobile}
                      </Text>
                    </td>
                    <td>
                      <Flex
                        sx={{
                          justifyContent: "center",
                          alignItems: "center",
                          height: "2.8rem",
                          borderRadius: "0.25rem",
                        }}
                      >
                        <Button
                          width="100%"
                          height="3rem"
                          rightIcon={<FaArrowRight />}
                          onClick={() => {
                            navigate({
                              pathname: "/users/details",
                              search: `?id=${item.id}`,
                            });
                          }}
                          style={{
                            background: theme.colors.primary.main,
                            color: theme.colors.bg.main,
                          }}
                        >
                          <Text sx={{ fontSize: theme.fontSizes.body }}>
                            {"View Details"}
                          </Text>
                        </Button>
                      </Flex>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <Box
              style={{
                padding: "2rem",
              }}
            >
              <Nodata heading="No Users Listed" />
            </Box>
          )}
        </Skeleton>

        <Box
          sx={{
            marginTop: theme.space.xl,
          }}
        >
          <Flex
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "3rem",
            }}
          >
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowBackIosNew}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={pageNumber !== 1 ? "pointer" : "not-allowed"}
                    onClick={() => {
                      if (pageNumber !== 1) {
                        setPageNumber(pageNumber - 1);
                        localStorage.setItem("userpage", `${pageNumber - 1}`);
                        setRefetchUrl(`/riders?page=${pageNumber - 1}`);
                      }
                    }}
                  />
                </Flex>
                <Text variant={"caption"}>Previous Page</Text>
              </Flex>
            </Box>
            <Skeleton
              isLoaded={isDataFetching ? false : true}
              sx={{ width: "2rem" }}
            >
              <Text variant={"body"}>{pageNumber}</Text>
            </Skeleton>
            <Box>
              <Flex
                sx={{
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "0.5rem",
                }}
              >
                <Text variant={"caption"}>Next Page</Text>
                <Flex
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "50%",
                    width: "2rem",
                    height: "2rem",
                  }}
                >
                  <Icon
                    as={MdArrowForwardIos}
                    boxSize={5}
                    color={theme.colors.primary.main}
                    cursor={nextNotAllowed ? "not-allowed" : "pointer"}
                    onClick={() => {
                      if (!nextNotAllowed) {
                        setPageNumber(pageNumber + 1);
                        localStorage.setItem("userpage", `${pageNumber + 1}`);
                        setRefetchUrl(`/riders?page=${pageNumber + 1}`);
                      }
                    }}
                  />
                </Flex>
              </Flex>
            </Box>
          </Flex>
        </Box>
      </Box>
    </Box>
  );
}

export default Index;
